// src/components/WorkflowList.js
import React, { useEffect, useState } from 'react'; // 添加 useState 导入
import { useWorkflows } from '../contexts/WorkflowContext';
import WorkflowItem from './WorkflowItem';
import SearchInput from './SearchInput';

const WorkflowList = () => {
  const { filterWorkflows, tags } = useWorkflows();
  const [showAdvanced, setShowAdvanced] = useState(false); // 默认收起来
  const filteredWorkflows = filterWorkflows();

  // 分离主要算法和备选算法
  const separateWorkflows = (workflows) => {
    const primary = {};
    const alternative = {};
    
    Object.entries(workflows).forEach(([category, files]) => {
      const primaryFiles = files.filter(file => !file.includes('(Algorithm 2)'));
      const alternativeFiles = files.filter(file => file.includes('(Algorithm 2)'));
      
      if (primaryFiles.length > 0) {
        primary[category] = primaryFiles;
      }
      if (alternativeFiles.length > 0) {
        alternative[category] = alternativeFiles;
      }
    });
    
    return { primary, alternative };
  };

  const { primary, alternative } = separateWorkflows(filteredWorkflows);
  const hasAlternatives = Object.keys(alternative).length > 0;

  // Add global drag end handler to ensure cleanup
  useEffect(() => {
    const handleGlobalDragEnd = () => {
      // Hide drag overlay at the end of any drag operation
      const dragOverlay = document.getElementById('drag-overlay');
      if (dragOverlay) {
        dragOverlay.style.display = 'none';
      }
      
      // Remove dragging class from all elements
      document.querySelectorAll('.dragging').forEach(el => {
        el.classList.remove('dragging');
      });
    };

    // Add global event listener for dragend
    document.addEventListener('dragend', handleGlobalDragEnd);
    
    return () => {
      document.removeEventListener('dragend', handleGlobalDragEnd);
    };
  }, []);

  return (
    <div id="content" style={{ padding: '0' }}>
      <SearchInput />
      
      {/* 显示主要算法 */}
      {Object.entries(primary).map(([category, files]) => (
        <div key={category} style={{ marginBottom: '20px' }}>
          <h2 style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '0.8rem',
            marginTop: '1.5rem',
            color: '#3288e6',
            backgroundColor: '#f0f7ff',
            padding: '8px 12px',
            borderRadius: '6px',
            borderLeft: '4px solid #3288e6'
          }}>
            {category}
          </h2>
          <div>
            {files.map((file) => (
              <WorkflowItem 
                key={file}
                file={file}
                tags={tags[file]}
              />
            ))}
          </div>
        </div>
      ))}

      {/* 显示备选算法（可折叠） */}
      {hasAlternatives && (
        <div style={{ marginBottom: '20px' }}>
          <div 
            onClick={() => setShowAdvanced(!showAdvanced)}
            style={{
              fontSize: '1.2rem',
              fontWeight: 'bold',
              marginBottom: '0.8rem',
              marginTop: '1.5rem',
              color: '#666',
              backgroundColor: '#f5f5f5',
              padding: '8px 12px',
              borderRadius: '6px',
              borderLeft: '4px solid #999',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'all 0.2s ease'
            }}
          >
            <span>Alternative Algorithms</span>
            <span style={{
              fontSize: '14px',
              transform: showAdvanced ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease'
            }}>
              ▼
            </span>
          </div>
          
          {showAdvanced && (
            <div style={{
              borderLeft: '2px solid #e0e0e0',
              paddingLeft: '10px',
              marginLeft: '10px'
            }}>
              {Object.entries(alternative).map(([category, files]) => (
                <div key={`alt-${category}`} style={{ marginBottom: '15px' }}>
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '500',
                    marginBottom: '0.5rem',
                    color: '#777',
                    backgroundColor: '#fafafa',
                    padding: '6px 10px',
                    borderRadius: '4px'
                  }}>
                    {category} - Alternative
                  </h3>
                  <div>
                    {files.map((file) => (
                      <WorkflowItem 
                        key={file}
                        file={file}
                        tags={tags[file]}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      
      {/* Add some CSS for drag visual feedback */}
      <style>{`
        .card.dragging {
          opacity: 0.7;
          transform: scale(0.95);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        
        @keyframes fadeInOut {
          0% { opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { opacity: 0; }
        }
        
        .duplicate-warning {
          animation: fadeInOut 3s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default WorkflowList;